export type ApiFieldErrors = Record<string, string>;

type ProblemErrorItem = {
  field?: unknown;
  message?: unknown;
};

type FastApi422Item = {
  loc?: unknown;
  msg?: unknown;
};

const coerceString = (value: unknown): string | null => {
  if (typeof value === 'string') return value;
  if (typeof value === 'number') return String(value);
  return null;
};

export const extractApiFieldErrors = (err: any): ApiFieldErrors => {
  const out: ApiFieldErrors = {};
  const problem = err?.problem;

  const problemErrors = problem?.errors;
  if (Array.isArray(problemErrors)) {
    for (const item of problemErrors as ProblemErrorItem[]) {
      const field = coerceString(item?.field);
      const message = coerceString(item?.message);
      if (field && message) out[field] = message;
    }
  }

  // FastAPI default 422 body: { detail: [{ loc: [...], msg: '...', ... }] }
  const detail = problem?.detail;
  if (Array.isArray(detail)) {
    for (const item of detail as FastApi422Item[]) {
      const loc = (item as any)?.loc;
      const msg = coerceString((item as any)?.msg);
      if (!msg) continue;
      if (!Array.isArray(loc) || loc.length === 0) continue;
      const field = coerceString(loc[loc.length - 1]);
      if (field) out[field] = msg;
    }
  }

  return out;
};

export const getApiErrorStatus = (err: unknown): number | null => {
  const status = (err as any)?.status;
  return typeof status === 'number' ? status : null;
};

export const getApiErrorCode = (err: unknown): string | null => {
  const code = (err as any)?.code;
  return typeof code === 'string' ? code : null;
};

export const isValidationProblem = (err: unknown): boolean => {
  const status = getApiErrorStatus(err);
  const code = getApiErrorCode(err);
  return status === 400 || status === 422 || code === 'VALIDATION_ERROR';
};

export const extractApiErrorMessage = (err: any): string | null => {
  const detail = coerceString(err?.detail);
  if (detail) return detail;
  const problemDetail = coerceString(err?.problem?.detail);
  if (problemDetail) return problemDetail;
  const message = coerceString(err?.message);
  if (message) return message;
  return null;
};
